<template>
  <div class="footer-social">
    <div class="container">
      <div class="footer-social_content">
        <img
          @click="goToTop()"
          class="logo"
          src="@/assets/images/logo.png"
          alt="logo"
        />
        <ul class="footer-social_content-icons">
          <a
            href="https://t.me/Centris_Media"
            class="icon"
            target="blank"
            rel="noopener"
          >
            <img class="icon-img" src="@/assets/images/icons/telegram.png" alt="" />
          </a>
          <a
            href="https://www.facebook.com/centrismedia.uz"
            class="icon"
            target="blank"
            rel="noopener"
          >
            <img class="icon-img" src="@/assets/images/icons/facebook.png" alt="" />
          </a>
          <a
            href="https://www.instagram.com/centris.media/"
            class="icon"
            target="blank"
            rel="noopener"
          >
            <img class="icon-img" src="@/assets/images/icons/instagram.png" alt="" />
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.footer-social {
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
  @include adaptivPaddinglg(0, 0, 40, 40, 0, 0, 20, 20);
  background: #2e2b2b;
  position: relative;
  @media (max-width: 768px) {
    @include adaptivPaddingmd(0, 0, 30, 30, 0, 0, 20, 20);
  }
  &_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      justify-content: center;
      align-items: center;
    }
    &-icons {
      display: flex;
      align-items: center;
      @media (max-width: 768px) {
        position: absolute;
        top: -60%;
        width: 45%;
        justify-content: space-between;
      }
      .icon {
        width: 80px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        filter: none;
        transform: scale(1);
        &:hover {
          filter: drop-shadow(3px 3px 1px #7338d8);
          transform: scale(1.2);
          transition: 0.5s;
        }
        @media (max-width: 768px) {
          width: 50px;
        }
        &-img {
          width: 22px;
          height: 22px;
          object-fit: contain;
          @media (min-width: 1921px) {
            width: 25px;
            height: 25px;
            object-fit: contain;
          }
          @media (max-width: 768px) {
            @include adaptivWidthmd(35, 18);
            width: 100%;
            @include adaptivHeightmd(35, 18);
            object-fit: contain;
          }
        }
      }
    }
    .logo {
      width: 100%;
      @include adaptivWidthLg(121, 110);
      & img {
        object-fit: cover;
      }
      @media (max-width: 768px) {
        @include adaptivWidthmd(160, 90);
      }
    }
  }
}
</style>